import { ActionTypes } from "../contants/action-type";

const initialState = {
    items: [],
    item: {}
}

export const ItemReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case ActionTypes.LIST_ITEM:
            return {...state, items: payload};
        case ActionTypes.SELECTED_ITEM:
            return {...state, item: payload};
        case ActionTypes.CONFIRM_CREATE_ITEM:
            return {...state, item: payload};
        case ActionTypes.CONFIRM_DELETE_ITEM:
            return {...state, items: payload};
        default:
            return state;
    }
}